module.exports = __webpack_public_path__ + "static/media/lk.f54e1ef9.svg";